import * as S from './styles.ts';
import RadioBlob, { IRadioBlobProps } from '@template/components/RadioBlob';

export interface ICheckboxProps {
  label?: any;
  name?: string;
  checked: boolean;
  onChange?: (checked: boolean) => void;
  readOnly?: boolean;
  blob?: Partial<IRadioBlobProps>;
  disabled?: boolean;
}

const Checkbox = ({
  label,
  name,
  checked,
  onChange,
  readOnly,
  blob,
  disabled,
}: ICheckboxProps) => {
  const handleChange = () => {
    if (disabled) return;
    onChange && onChange(!checked);
  };
  return (
    <S.CheckboxWrapper>
      <S.CheckboxContainer>
        <S.HiddenCheckbox
          name={name}
          id='my-checkbox'
          checked={checked}
          onChange={handleChange}
          readOnly={readOnly}
          disabled={readOnly}
        />
        <RadioBlob
          selected={checked}
          variant='check'
          size='md'
          disabled={disabled}
          {...blob}
        />
      </S.CheckboxContainer>
      {label && <S.CheckboxLabel>{label}</S.CheckboxLabel>}
    </S.CheckboxWrapper>
  );
};

export default Checkbox;
